module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "q_main_content"
  }, [_c('div', {
    staticClass: "q_content"
  }, [_c('div', {
    staticClass: "pos"
  }, [_c('div', {
    staticClass: "pos-topheader"
  }, [_c('div', {
    staticClass: "pos-branding"
  }, [_c('span', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.cashierName))])]), _vm._v(" "), _c('div', {
    staticClass: "pos-rightheader"
  }, [_c('div', {
    staticClass: "order-selector"
  }, [_c('span', {
    staticClass: "orders touch-scrollable"
  }, [_c('span', {
    staticClass: "order-button select-order selected",
    attrs: {
      "data-uid": "00001-001-0003"
    }
  }, [_c('span', {
    staticClass: "order-sequence"
  }, [_vm._v("\n                            " + _vm._s(_vm.sessionNo) + "\n                        ")]), _vm._v("\n                        " + _vm._s(_vm.sessionTime) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "oe_status js_synch"
  }), _vm._v(" "), _c('div', {
    staticClass: "header-button",
    on: {
      "click": function($event) {
        _vm.onClose()
      }
    }
  }, [_vm._v("\n                Close\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "pos-content"
  }, [_c('div', {
    staticClass: "window"
  }, [_c('div', {
    staticClass: "subwindow"
  }, [_c('div', {
    staticClass: "subwindow-container"
  }, [_c('div', {
    staticClass: "subwindow-container-fix screens"
  }, [_vm._m(0), _vm._v(" "), (_vm.viewType == _vm.VIEW_INITIAL) ? _c('div', {
    staticClass: "product-screen screen"
  }, [_c('div', {
    staticClass: "leftpane"
  }, [_c('div', {
    staticClass: "window"
  }, [_c('div', {
    staticClass: "subwindow"
  }, [_c('div', {
    staticClass: "subwindow-container"
  }, [_c('div', {
    staticClass: "subwindow-container-fix"
  }, [_c('div', {
    staticClass: "order-container"
  }, [_c('div', {
    staticClass: "order-scroller touch-scrollable"
  }, [_c('div', {
    staticClass: "order"
  }, [_c('ul', {
    staticClass: "orderlines"
  }, _vm._l((_vm.listCart), function(row, i) {
    return _c('li', {
      key: i,
      staticClass: "orderline",
      class: {
        selected: _vm.cartItemIndex == i
      },
      on: {
        "click": function($event) {
          _vm.cartItemIndex = i
        }
      }
    }, [_c('span', {
      staticClass: "product-name"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_vm._v(_vm._s(_vm.displayNumber(row.qty * row.price)))]), _vm._v(" "), _c('ul', {
      staticClass: "info-list"
    }, [_c('li', {
      staticClass: "info"
    }, [_c('em', [_vm._v(_vm._s(_vm.displayNumber(row.qty)) + " ")]), _vm._v(_vm._s(row.uom) + " at " + _vm._s(_vm.displayNumber(row.price)) + "/" + _vm._s(row.uom) + "\n                                                        ")])])])
  })), _vm._v(" "), (this.emptyCartStatus != _vm.EMPTY_CART) ? _c('div', {
    staticClass: "summary clearfix"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "entry total"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Total: ")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.totalAmount))]), _vm._v(" "), _c('div', {
    staticClass: "subentry"
  }, [_vm._v("Taxes: "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.taxAmount))])])])])]) : _vm._e(), _vm._v(" "), (this.emptyCartStatus === _vm.EMPTY_CART) ? _c('div', {
    staticClass: "order-empty"
  }, [_c('i', {
    staticClass: "icon ion-shopping-cart"
  }), _vm._v(" "), _c('h1', [_vm._v("Your shopping cart is empty")])]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "subwindow collapsed"
  }, [_c('div', {
    staticClass: "subwindow-container"
  }, [_c('div', {
    staticClass: "subwindow-container-fix pads"
  }, [_c('div', {
    staticClass: "control-buttons oe_hidden"
  }), _vm._v(" "), _c('div', {
    staticClass: "actionpad"
  }, [_c('button', {
    staticClass: "button set-customer",
    on: {
      "click": function($event) {
        _vm.onDisplayScreenCustomer(_vm.viewType)
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-user"
  }), _vm._v("                                                                                                                                                 \n                                                " + _vm._s(_vm.customerSelectedName) + "                                                                        \n                                            ")]), _vm._v(" "), _c('button', {
    staticClass: "button pay",
    on: {
      "click": function($event) {
        _vm.onPayment()
      }
    }
  }, [_vm._m(1), _vm._v("\n                                                Payment\n                                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "numpad"
  }, [_c('button', {
    staticClass: "input-button number-char",
    on: {
      "click": function($event) {
        _vm.onClickNumpad('1')
      }
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('button', {
    staticClass: "input-button number-char",
    on: {
      "click": function($event) {
        _vm.onClickNumpad('2')
      }
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('button', {
    staticClass: "input-button number-char",
    on: {
      "click": function($event) {
        _vm.onClickNumpad('3')
      }
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('button', {
    staticClass: "mode-button selected-mode",
    attrs: {
      "data-mode": "quantity"
    },
    on: {
      "click": function($event) {
        _vm.onClickNumpad('Qty')
      }
    }
  }, [_vm._v("Qty")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "input-button number-char",
    on: {
      "click": function($event) {
        _vm.onClickNumpad('4')
      }
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('button', {
    staticClass: "input-button number-char",
    on: {
      "click": function($event) {
        _vm.onClickNumpad('5')
      }
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('button', {
    staticClass: "input-button number-char",
    on: {
      "click": function($event) {
        _vm.onClickNumpad('6')
      }
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('button', {
    staticClass: "mode-button",
    attrs: {
      "data-mode": "discount"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "input-button number-char",
    on: {
      "click": function($event) {
        _vm.onClickNumpad('7')
      }
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('button', {
    staticClass: "input-button number-char",
    on: {
      "click": function($event) {
        _vm.onClickNumpad('8')
      }
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('button', {
    staticClass: "input-button number-char",
    on: {
      "click": function($event) {
        _vm.onClickNumpad('9')
      }
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('button', {
    staticClass: "mode-button",
    attrs: {
      "data-mode": "price"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "input-button numpad-minus"
  }), _vm._v(" "), _c('button', {
    staticClass: "input-button number-char",
    on: {
      "click": function($event) {
        _vm.onClickNumpad('0')
      }
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('button', {
    staticClass: "input-button number-char",
    on: {
      "click": function($event) {
        _vm.onClickNumpad(',')
      }
    }
  }, [_vm._v(",")]), _vm._v(" "), _c('button', {
    staticClass: "input-button numpad-backspace",
    on: {
      "click": function($event) {
        _vm.onClickNumpad('BACKSPACE')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "pointer-events": "none"
    },
    attrs: {
      "height": "21",
      "src": "/static/img/backspace.png",
      "width": "24"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "rightpane"
  }, [_c('table', {
    staticClass: "layout-table"
  }, [_c('tbody', [_c('tr', {
    staticClass: "header-row"
  }, [_c('td', {
    staticClass: "header-cell"
  }, [_c('div', [_c('header', {
    staticClass: "rightpane-header"
  }, [_c('div', {
    staticClass: "breadcrumbs"
  }, [_c('span', {
    staticClass: "breadcrumb-pos"
  }, [_c('span', {
    staticClass: "breadcrumb-button breadcrumb-home js-category-switch",
    on: {
      "click": function($event) {
        _vm.onDisplayScreenOrder(_vm.viewType)
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-printer"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "breadcrumb-pos"
  }, [_c('span', {
    staticClass: "breadcrumb-button breadcrumb-home js-category-switch",
    on: {
      "click": function($event) {
        _vm.onClickHomeBreadCrumb()
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-home"
  })])]), _vm._v(" "), _vm._l((_vm.listBreadCrumb), function(row, i) {
    return _c('span', {
      key: i,
      staticClass: "breadcrumb-pos"
    }, [_c('img', {
      staticClass: "breadcrumb-arrow",
      attrs: {
        "src": "/static/img/bc-arrow-big.png"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "breadcrumb-button js-category-switch",
      attrs: {
        "data-category-id": row.id
      }
    }, [_vm._v("\n                                                            " + _vm._s(row.name) + "\n                                                        ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "searchbox"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Search Products"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.onSearchProduct($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "search-clear"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "categories"
  }, [_c('div', {
    staticClass: "category-list-scroller touch-scrollable"
  }, [_c('div', {
    staticClass: "category-list simple"
  }, _vm._l((_vm.listProductCategory), function(row, i) {
    return _c('span', {
      key: i,
      staticClass: "category-simple-button js-category-switch",
      attrs: {
        "data-category-id": row.id
      },
      on: {
        "click": function($event) {
          _vm.onClickProductCategory(row)
        }
      }
    }, [_vm._v("\n                                                            " + _vm._s(row.name) + "\n                                                        ")])
  }))])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "content-row"
  }, [_c('td', {
    staticClass: "content-cell"
  }, [_c('div', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "product-list-container"
  }, [_c('div', {
    staticClass: "product-list-scroller touch-scrollable"
  }, [_c('div', {
    staticClass: "product-list"
  }, _vm._l((_vm.listProduct), function(row, i) {
    return _c('span', {
      key: i,
      staticClass: "product",
      attrs: {
        "data-product-id": row.id
      },
      on: {
        "click": function($event) {
          _vm.onSelectProduct(row)
        }
      }
    }, [_c('div', {
      staticClass: "product-img"
    }, [_c('img', {
      attrs: {
        "src": '/image/Product/' + row.imageUrl
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "price-tag"
    }, [_vm._v("\n                                                                    " + _vm._s(row.currentPrice) + "\n                                                                ")])]), _vm._v(" "), _c('div', {
      staticClass: "product-name"
    }, [_vm._v("\n                                                                " + _vm._s(row.name) + "\n                                                            ")])])
  })), _vm._v(" "), _c('span', {
    staticClass: "placeholder-ScrollbarWidget"
  })])])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.viewType == _vm.VIEW_CUSTOMER) ? _c('div', {
    staticClass: "clientlist-screen screen"
  }, [_c('div', {
    staticClass: "screen-content"
  }, [_c('section', {
    staticClass: "top-content"
  }, [_c('span', {
    staticClass: "button back",
    on: {
      "click": function($event) {
        _vm.onBackCustomer()
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-angle-double-left"
  }), _vm._v("\n                            Cancel\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "searchbox"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Search Customers"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.onSearchMember($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "search-clear"
  })]), _vm._v(" "), _c('span', {
    staticClass: "button next highlight",
    on: {
      "click": _vm.onSetCustomer
    }
  }, [_vm._v(_vm._s(_vm.textButtonSetCustomer))])]), _vm._v(" "), _c('section', {
    staticClass: "full-content"
  }, [_c('div', {
    staticClass: "window"
  }, [_c('section', {
    staticClass: "subwindow collapsed"
  }, [_c('div', {
    staticClass: "subwindow-container collapsed"
  }, [_c('div', {
    staticClass: "subwindow-container-fix client-details-contents"
  }, [_c('section', {
    staticClass: "client-details"
  }, [_c('div', {
    staticClass: "client-picture"
  }, [_c('img', {
    attrs: {
      "src": _vm.customerData.imageUrl == '' ? '/static/img/placeholder.png' : '/image/Guest/' + _vm.customerData.imageUrl + '?' + Date.now()
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "client-name"
  }, [_vm._v(_vm._s(_vm.customerData.name))]), _vm._v(" "), _c('div', {
    staticClass: "client-details-box clearfix"
  }, [_c('div', {
    staticClass: "client-details-left"
  }, [_c('div', {
    staticClass: "client-detail"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('span', {
    staticClass: "detail client-email"
  }, [_vm._v(_vm._s(_vm.customerData.emailAddress))])])]), _vm._v(" "), _c('div', {
    staticClass: "client-details-right"
  }, [_c('div', {
    staticClass: "client-detail"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Member No.")]), _vm._v(" "), _c('span', {
    staticClass: "detail client-id"
  }, [_vm._v(_vm._s(_vm.customerData.memberNo))])])])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "subwindow"
  }, [_c('div', {
    staticClass: "subwindow-container"
  }, [_c('div', {
    staticClass: "subwindow-container-fix touch-scrollable scrollable-y"
  }, [_c('table', {
    staticClass: "client-list"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', {
    staticClass: "client-list-contents"
  }, _vm._l((_vm.listCustomer), function(row, i) {
    return _c('tr', {
      key: i,
      staticClass: "client-line",
      class: {
        highlight: _vm.customerIndex == i
      },
      on: {
        "click": function($event) {
          _vm.onChooseCustomer(row, i)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(row.firstName + ' ' + row.lastName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.emailAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.memberNo))])])
  }))])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.viewType == _vm.VIEW_PAYMENT) ? _c('div', {
    staticClass: "payment-screen screen"
  }, [_c('div', {
    staticClass: "screen-content"
  }, [_c('div', {
    staticClass: "top-content"
  }, [_c('span', {
    staticClass: "button back",
    on: {
      "click": function($event) {
        _vm.onBackPayment()
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-angle-double-left"
  }), _vm._v("\n                        Back\n                      ")]), _vm._v(" "), _c('h1', [_vm._v("Payment")]), _vm._v(" "), _c('span', {
    staticClass: "button next highlight",
    on: {
      "click": function($event) {
        _vm.onPreValidatePayment()
      }
    }
  }, [_vm._v("\n                        Validate\n                        "), _c('i', {
    staticClass: "icon ion-angle-double-right"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "left-content pc40 touch-scrollable scrollable-y"
  }, [_c('div', {
    staticClass: "paymentmethods-container"
  }, [_c('div', {
    staticClass: "paymentmethods"
  }, _vm._l((_vm.listPaymentMethod), function(row, i) {
    return _c('div', {
      key: i,
      staticClass: "button paymentmethod",
      on: {
        "click": function($event) {
          _vm.onSelectPaymentMethod(row)
        }
      }
    }, [_vm._v("\n                              " + _vm._s(row.paymentMethodName) + "\n                          ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "right-content pc60 touch-scrollable scrollable-y"
  }, [(_vm.emptyPaymentMethod) ? _c('section', {
    staticClass: "paymentlines-container"
  }, [_c('div', {
    staticClass: "paymentlines-empty"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("\n                              " + _vm._s(_vm.totalAmount) + "\n                          ")]), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_vm._v("\n                              Please select a payment method. \n                          ")])])]) : _vm._e(), _vm._v(" "), (!_vm.emptyPaymentMethod) ? _c('section', {
    staticClass: "paymentlines-container"
  }, [_c('table', {
    staticClass: "paymentlines"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.listPaymentLine), function(row, i) {
    return _c('tr', {
      key: i,
      staticClass: "paymentline",
      class: {
        selected: _vm.paymentLineIndex == i
      },
      on: {
        "click": function($event) {
          _vm.onSelectPaymentLine(row, i)
        }
      }
    }, [_c('td', {
      staticClass: "col-due"
    }, [_vm._v(" " + _vm._s(row.due) + " ")]), _vm._v(" "), _c('td', {
      staticClass: "col-tendered",
      class: {
        edit: _vm.paymentLineIndex == i
      }
    }, [_vm._v(_vm._s(row.tendered))]), _vm._v(" "), _c('td', {
      staticClass: "col-change",
      class: {
        highlight: row.change != '' && _vm.paymentLineIndex == i
      }
    }, [_vm._v(_vm._s(row.change))]), _vm._v(" "), _c('td', {
      staticClass: "col-name"
    }, [_vm._v(" " + _vm._s(row.method) + " ")]), _vm._v(" "), _c('td', {
      staticClass: "col-cardno"
    }, [_vm._v(_vm._s(row.cardno))]), _vm._v(" "), _c('td', {
      staticClass: "delete-button",
      on: {
        "click": function($event) {
          _vm.onDeletePaymentLine(i)
        }
      }
    }, [_c('i', {
      staticClass: "icon ion-times-circle"
    })])])
  }))])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "payment-numpad"
  }, [_c('div', {
    staticClass: "numpad"
  }, [_c('button', {
    staticClass: "input-button number-char",
    on: {
      "click": function($event) {
        _vm.onClickPaymentNumpad('1')
      }
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('button', {
    staticClass: "input-button number-char",
    on: {
      "click": function($event) {
        _vm.onClickPaymentNumpad('2')
      }
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('button', {
    staticClass: "input-button number-char",
    on: {
      "click": function($event) {
        _vm.onClickPaymentNumpad('3')
      }
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('button', {
    staticClass: "mode-button",
    attrs: {
      "id": "TENDERED"
    },
    on: {
      "click": function($event) {
        _vm.onClickPaymentNumpad('TENDERED')
      }
    }
  }, [_vm._v("Tendered")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "input-button number-char",
    on: {
      "click": function($event) {
        _vm.onClickPaymentNumpad('4')
      }
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('button', {
    staticClass: "input-button number-char",
    on: {
      "click": function($event) {
        _vm.onClickPaymentNumpad('5')
      }
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('button', {
    staticClass: "input-button number-char",
    on: {
      "click": function($event) {
        _vm.onClickPaymentNumpad('6')
      }
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('button', {
    staticClass: "mode-button",
    attrs: {
      "id": "CARDNO"
    },
    on: {
      "click": function($event) {
        _vm.onClickPaymentNumpad('CARDNO')
      }
    }
  }, [_vm._v("Card No")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "input-button number-char",
    on: {
      "click": function($event) {
        _vm.onClickPaymentNumpad('7')
      }
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('button', {
    staticClass: "input-button number-char",
    on: {
      "click": function($event) {
        _vm.onClickPaymentNumpad('8')
      }
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('button', {
    staticClass: "input-button number-char",
    on: {
      "click": function($event) {
        _vm.onClickPaymentNumpad('9')
      }
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('button', {
    staticClass: "input-button number-char",
    on: {
      "click": function($event) {
        _vm.onClickPaymentNumpad('.000')
      }
    }
  }, [_vm._v(".000")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "input-button numpad-char",
    on: {
      "click": function($event) {
        _vm.onClickPaymentNumpad('CLEAR')
      }
    }
  }, [_vm._v("C")]), _vm._v(" "), _c('button', {
    staticClass: "input-button number-char",
    on: {
      "click": function($event) {
        _vm.onClickPaymentNumpad('0')
      }
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('button', {
    staticClass: "input-button number-char"
  }), _vm._v(" "), _c('button', {
    staticClass: "input-button numpad-backspace",
    on: {
      "click": function($event) {
        _vm.onClickPaymentNumpad('BACKSPACE')
      }
    }
  }, [_c('img', {
    attrs: {
      "height": "21",
      "src": "/static/img/backspace.png",
      "width": "24"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "payment-buttons"
  }, [_c('div', {
    staticClass: "button js_set_customer",
    on: {
      "click": function($event) {
        _vm.onDisplayScreenCustomer(_vm.viewType)
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "js_customer_name"
  }, [_vm._v(_vm._s(_vm.customerSelectedName))])])])])])]) : _vm._e(), _vm._v(" "), (_vm.viewType == _vm.VIEW_ORDER) ? _c('div', {
    staticClass: "clientlist-screen screen"
  }, [_c('div', {
    staticClass: "screen-content"
  }, [_c('section', {
    staticClass: "top-content"
  }, [_c('span', {
    staticClass: "button back",
    on: {
      "click": function($event) {
        _vm.onBackCustomer()
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-angle-double-left"
  }), _vm._v("\n                            Cancel\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "searchbox"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Search Doc. Number"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.onSearchOrder($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "search-clear"
  })]), _vm._v(" "), _c('span', {
    staticClass: "button next highlight",
    on: {
      "click": function($event) {
        _vm.onRePrint()
      }
    }
  }, [_vm._v(_vm._s(_vm.textButtonSetOrder))])]), _vm._v(" "), _c('section', {
    staticClass: "full-content"
  }, [_c('div', {
    staticClass: "window"
  }, [_c('section', {
    staticClass: "subwindow collapsed"
  }, [_c('div', {
    staticClass: "subwindow-container collapsed"
  }, [_c('div', {
    staticClass: "subwindow-container-fix client-details-contents"
  }, [_c('section', {
    staticClass: "client-details"
  }, [_c('div', {
    staticClass: "client-name"
  }, [_vm._v(_vm._s(_vm.orderData.name))]), _vm._v(" "), _c('div', {
    staticClass: "client-details-box clearfix"
  }, [_c('div', {
    staticClass: "client-details-left"
  }, [_c('div', {
    staticClass: "client-detail"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Document Date")]), _vm._v(" "), _c('span', {
    staticClass: "detail client-email"
  }, [_vm._v(_vm._s(_vm.orderData.documentDate))])])]), _vm._v(" "), _c('div', {
    staticClass: "client-details-right"
  }, [_c('div', {
    staticClass: "client-detail"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Amount")]), _vm._v(" "), _c('span', {
    staticClass: "detail client-id"
  }, [_vm._v(_vm._s(_vm.orderData.amount))])])]), _vm._v(" "), _c('div', {
    staticClass: "client-details-right"
  }, [_c('div', {
    staticClass: "client-detail"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('span', {
    staticClass: "detail client-id"
  }, [_vm._v(_vm._s(_vm.orderData.status))])])])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "subwindow"
  }, [_c('div', {
    staticClass: "subwindow-container"
  }, [_c('div', {
    staticClass: "subwindow-container-fix touch-scrollable scrollable-y"
  }, [_c('table', {
    staticClass: "client-list"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', {
    staticClass: "client-list-contents"
  }, _vm._l((_vm.listOrder), function(row, i) {
    return _c('tr', {
      key: i,
      staticClass: "client-line",
      class: {
        highlight: _vm.orderIndex == i
      },
      on: {
        "click": function($event) {
          _vm.onChooseOrder(row, i)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.documentDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.totalAmountIncludeTax))])])
  }))])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.viewType == _vm.VIEW_RECEIPT) ? _c('div', {
    staticClass: "receipt-screen screen"
  }, [_c('div', {
    staticClass: "screen-content"
  }, [_c('div', {
    staticClass: "top-content"
  }, [_c('h1', [_vm._v("Change: "), _c('span', {
    staticClass: "change-value"
  }, [_vm._v(_vm._s(_vm.changeAmount))])]), _vm._v(" "), _c('span', {
    staticClass: "button next highlight",
    on: {
      "click": function($event) {
        _vm.onNextOrder()
      }
    }
  }, [_vm._v("\n                        Next Order\n                        "), _c('i', {
    staticClass: "icon ion-angle-double-right"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "centered-content touch-scrollable"
  }, [_c('div', {
    staticClass: "button print",
    on: {
      "click": function($event) {
        _vm.onPrintReceiptMember(_vm.listOrder)
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-printer"
  }), _vm._v(" Print Membership\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "button print",
    on: {
      "click": function($event) {
        _vm.onPrintReceipt()
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-printer"
  }), _vm._v(" Print Receipt\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "pos-receipt-container",
    attrs: {
      "id": "printableArea"
    }
  }, [_c('div', {
    staticClass: "pos-sale-ticket"
  }, [_c('img', {
    attrs: {
      "src": '/image/Project/' + _vm.projectImageUrl,
      "height": "60px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pos-center-align"
  }, [_vm._v(_vm._s(_vm.orderDate))]), _vm._v(" "), _c('div', {
    staticClass: "pos-center-align"
  }, [_vm._v(_vm._s(_vm.orderNo))]), _vm._v(" "), _c('br'), _vm._v("\n                          Project: " + _vm._s(_vm.projectName)), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "receipt-user"
  }, [_vm._v("\n                            Cashier: " + _vm._s(_vm.cashierName)), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "receipt-membership"
  }, [_vm._v("\n                            Customer: " + _vm._s(_vm.customerSelectedName)), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "receipt-orderlines"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.itemReceipt), function(row, i) {
    return _c('tr', {
      key: i
    }, [_c('td', [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
      staticClass: "pos-right-align"
    }, [_vm._v(_vm._s(row.quantity) + " " + _vm._s(row.uom))]), _vm._v(" "), _c('td', {
      staticClass: "pos-right-align"
    }, [_vm._v(_vm._s(row.amount))])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "receipt-total"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Subtotal:")]), _vm._v(" "), _c('td', {
    staticClass: "pos-right-align"
  }, [_vm._v(_vm._s(_vm.subTotalAmount))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Tax:")]), _vm._v(" "), _c('td', {
    staticClass: "pos-right-align"
  }, [_vm._v(_vm._s(_vm.taxAmount))])]), _vm._v(" "), _c('tr', {
    staticClass: "emph"
  }, [_c('td', [_vm._v("Total:")]), _vm._v(" "), _c('td', {
    staticClass: "pos-right-align"
  }, [_vm._v(_vm._s(_vm.totalAmount))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "receipt-paymentlines"
  }, [_c('tbody', _vm._l((_vm.listPaymentLine), function(row, i) {
    return _c('tr', {
      key: i
    }, [_c('td', [_vm._v("\n                                  " + _vm._s(row.method) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticClass: "pos-right-align"
    }, [_vm._v("\n                                  " + _vm._s(row.tendered) + "\n                                ")])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "receipt-change"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Change:")]), _vm._v(" "), _c('td', {
    staticClass: "pos-right-align"
  }, [_vm._v("\n                                " + _vm._s(_vm.changeAmount) + "\n                                ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "receipt-paymentlines"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("RRN:")]), _vm._v(" "), _c('td', {
    staticClass: "pos-right-align"
  }, [_vm._v("\n                                " + _vm._s(_vm.rrnNumber) + "\n                                ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "receipt-orderlines"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.passCodes), function(row, i) {
    return _c('tr', {
      key: i,
      staticStyle: {
        "display": "block",
        "padding-top": "20px"
      }
    }, [_c('td', [_c('div', {
      attrs: {
        "id": ("passCode-" + (row.id))
      }
    })])])
  }))])])])])])]) : _vm._e()])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade modal-dialog modal-lg ",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "modal-view-file"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "btnCloseModal",
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onPrintPdf()
      }
    }
  }, [_vm._v("Print")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-dialog-qris",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "modal-qris"
    }
  }, [_c('div', {
    staticClass: "popup"
  }, [_c('h2', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("Please scan QRIS")]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v(_vm._s(_vm.elapsedTime))]), _vm._v(" "), _c('div', {
    staticClass: "qris",
    attrs: {
      "id": "qrcode"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "message"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onCancelQRIS()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onResumeGetStatus()
      }
    }
  }, [_vm._v("Resume")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scale-screen screen oe_hidden"
  }, [_c('div', {
    staticClass: "screen-content"
  }, [_c('div', {
    staticClass: "top-content"
  }, [_c('span', {
    staticClass: "button back"
  }, [_c('i', {
    staticClass: "icon ion-angle-double-left"
  }), _vm._v("\n                                Back\n                            ")]), _vm._v(" "), _c('h1', {
    staticClass: "product-name"
  }, [_vm._v("Unnamed Product")])]), _vm._v(" "), _c('div', {
    staticClass: "centered-content"
  }, [_c('div', {
    staticClass: "weight js-weight"
  }, [_vm._v("\n                                0.000 Kg\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "product-price"
  }, [_vm._v("\n                                Rp 0.00/\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "computed-price"
  }, [_vm._v("\n                                123.14 €\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "buy-product"
  }, [_vm._v("\n                                Order\n                                "), _c('i', {
    staticClass: "icon ion-angle-double-right"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pay-circle"
  }, [_c('i', {
    staticClass: "icon ion-chevron-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Email Address")]), _vm._v(" "), _c('th', [_vm._v("Member No.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticClass: "due"
  }), _vm._v(" "), _c('col', {
    staticClass: "tendered"
  }), _vm._v(" "), _c('col', {
    staticClass: "change"
  }), _vm._v(" "), _c('col', {
    staticClass: "method"
  }), _vm._v(" "), _c('col', {
    staticClass: "cardno"
  }), _vm._v(" "), _c('col', {
    staticClass: "controls"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "label"
  }, [_c('th', [_vm._v("Due")]), _vm._v(" "), _c('th', [_vm._v("Tendered")]), _vm._v(" "), _c('th', [_vm._v("Change")]), _vm._v(" "), _c('th', [_vm._v("Method")]), _vm._v(" "), _c('th', [_vm._v("Card No.")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Doc. Number")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Amount")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    attrs: {
      "width": "50%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "25%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    attrs: {
      "width": "100%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('iframe', {
    staticStyle: {
      "width": "95%",
      "height": "360px",
      "border": "1px"
    },
    attrs: {
      "id": "viewer"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7aed93e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/PointOfSales/PointOfSales.vue
// module id = 759
// module chunks = 1